<template>
	<InputPhone
		v-model="context.model"
		:no-country-selector="false"
		:disabled="context.attributes.disabled"
		@validatePhone="validatePhone"
	/>
</template>
<script>
import InputPhone from '~/components/dev/InputPhone.vue';

export default {
	components: {
		InputPhone,
	},
	props: {
		context: {
			type: Object,
			required: true,
		},
	},
	watch: {
		'context.model'(value) {
			this.context.rootEmit('update:model', value);
		},
	},
	methods: {
		validatePhone(value) {
			this.context.rootEmit('validatePhone', value);
		},
	},
};
</script>
<style>

</style>
